class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
    this.content = null;
    this.mobileQuery = null;
    this.frame = 0;
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    this.footer = document.querySelector('[data-ref="footer"], .cr-footer');
    this.content = this.querySelector('.sticky-add-to-cart__content');

    if (!this.form || !this.content || this.closest('dialog')) return;

    this.form.addEventListener('variant:updated', this.updateSummary);
    this.mobileQuery = matchMedia('(max-width: 749px)');

    // Réserve l'espace du sticky dans le flux pour éviter le changement de
    // hauteur du document quand le contenu passe en position: fixed. Sans cela,
    // le contenu sort du flux → la page raccourcit → le footer remonte dans le
    // viewport → le sticky se désactive → boucle infinie de clignotement.
    requestAnimationFrame(() => {
      this.style.minHeight = `${this.offsetHeight}px`;
      window.addEventListener('scroll', this.#scheduleUpdate, { passive: true });
      window.addEventListener('resize', this.#scheduleUpdate, { passive: true });
      this.mobileQuery.addEventListener('change', this.#scheduleUpdate);
      this.#evaluate();
    });
  }

  disconnectedCallback() {
    this.form?.removeEventListener('variant:updated', this.updateSummary);
    window.removeEventListener('scroll', this.#scheduleUpdate);
    window.removeEventListener('resize', this.#scheduleUpdate);
    this.mobileQuery?.removeEventListener('change', this.#scheduleUpdate);
    cancelAnimationFrame(this.frame);
    clearTimeout(this.closingTimeout);
  }

  updateSummary = (event) => {
    const variant = event.detail?.resource;
    const summary = this.content?.querySelector('[data-cr-sticky-variant]');
    if (summary) summary.textContent = variant?.title === 'Default Title' ? '' : variant?.title || '';
    const sourceImage = event.detail?.data?.html?.querySelector('.cr-sticky-product img');
    const image = this.content?.querySelector('.cr-sticky-product img');
    if (sourceImage && image) image.replaceWith(sourceImage.cloneNode(true));
  };

  #scheduleUpdate = () => {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.#evaluate());
  };

  /**
   * Réglages du bloc (data-*) :
   * - trigger / trigger-mobile : « hidden » dès que le bouton principal n'est plus entièrement visible,
   *   « passed » une fois le bouton dépassé (comportement d'origine), « off » jamais ;
   * - offset / offset-mobile : défilement minimal en px avant tout affichage ;
   * - hide-footer : masquer quand le pied de page est à l'écran ;
   * - hide-variants-mobile : sur mobile, masquer tant que le sélecteur de variantes est à l'écran.
   * La barre disparaît toujours quand le bouton principal est entièrement visible (pas de doublon).
   */
  #evaluate() {
    if (!this.isConnected) return;
    const mobile = this.mobileQuery.matches;
    const trigger = (mobile ? this.dataset.triggerMobile : this.dataset.trigger) || 'passed';
    const offset = Number(mobile ? this.dataset.offsetMobile : this.dataset.offset) || 0;
    const viewport = window.innerHeight;
    const rect = this.getBoundingClientRect();
    const fullyVisible = rect.top >= 0 && rect.bottom <= viewport;
    const passed = rect.bottom <= 0;

    let show = trigger === 'hidden' ? !fullyVisible : trigger === 'passed' ? passed : false;
    if (window.scrollY < offset) show = false;
    if (show && this.dataset.hideFooter !== 'false' && this.footer) {
      show = this.footer.getBoundingClientRect().top >= viewport;
    }
    if (show && mobile && this.dataset.hideVariantsMobile === 'true') {
      const picker = this.form.querySelector('variant-picker');
      const box = picker?.getBoundingClientRect();
      if (box && box.height && box.bottom > 0 && box.top < viewport) show = false;
    }
    this.#updateDisplay(show);
  }

  #updateDisplay(shouldBeActive) {
    const isActive = this.dataset.active === 'true';

    if (shouldBeActive === isActive) return;

    clearTimeout(this.closingTimeout);

    if (shouldBeActive) {
      delete this.dataset.closing;
      this.dataset.active = 'true';
      this.content.classList.add('color-scheme-1');
      this.content.querySelector('[data-cr-sticky-variant]')?.replaceChildren(document.createTextNode(this.form.querySelector('variant-picker script[type="application/json"]')?.textContent ? JSON.parse(this.form.querySelector('variant-picker script[type="application/json"]').textContent)?.title || '' : ''));
      return;
    }

    this.dataset.active = 'false';
    this.dataset.closing = 'true';

    this.closingTimeout = setTimeout(() => {
      delete this.dataset.closing;
      this.content.classList.remove('color-scheme-1');
    }, 300);
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
